var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDeleteTool = function SvgDeleteTool(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 34
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    d: "M28 9c0-.542-.458-1-1-1H9c-.542 0-1 .458-1 1v16c0 .542.458 1 1 1h18c.542 0 1-.458 1-1V9zm2 0v16c0 1.65-1.35 3-3 3H9c-1.65 0-3-1.35-3-3V9c0-1.65 1.35-3 3-3h18c1.65 0 3 1.35 3 3zm-5.636 3.757L20.121 17l4.243 4.243a.5.5 0 0 1 0 .707l-1.414 1.414a.499.499 0 0 1-.707 0L18 19.121l-4.243 4.243a.499.499 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 0-.707L15.879 17l-4.243-4.243a.5.5 0 0 1 0-.707l1.414-1.414a.499.499 0 0 1 .707 0L18 14.879l4.243-4.243a.499.499 0 0 1 .707 0l1.414 1.414a.5.5 0 0 1 0 .707z",
    fillRule: "evenodd"
  })));
};

export default SvgDeleteTool;